import React from 'react';

export const FileUpload = () => (
    <>
        <path d='M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1' />
        <polyline points='9 15 12 12 15 15' />
        <line x1='12' y1='12' x2='12' y2='21' />
    </>
);